export default __webpack_public_path__ + "static/map02-2ccc9d4b34a2ed059cc4d47ab822a46d.jpg";